var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    { staticClass: "page" },
    [
      _c("el-row", { attrs: { gutter: 20 } }),
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.$refs.addYlProductMapping.open()
                    }
                  }
                },
                [_vm._v("新增")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "warning", disabled: _vm.sels.length == 0 },
                  on: {
                    click: function($event) {
                      return _vm.handleDelete(_vm.selsString)
                    }
                  }
                },
                [_vm._v("批量删除")]
              )
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "operationBut", attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.reqLoading },
                  on: {
                    click: function($event) {
                      return _vm.searchClick(1)
                    }
                  }
                },
                [_vm._v("搜索")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.reqLoading,
              expression: "reqLoading"
            }
          ],
          ref: "tableRef",
          attrs: { id: "tableRef", data: _vm.tableData, border: "" },
          on: { "selection-change": _vm.handleSelectionChange }
        },
        [
          _c("el-table-column", {
            attrs: { prop: "id", type: "selection", label: "ID", width: "60" }
          }),
          _c("el-table-column", { attrs: { prop: "game", label: "游戏" } }),
          _c("el-table-column", { attrs: { prop: "platform", label: "平台" } }),
          _c("el-table-column", { attrs: { prop: "pkg", label: "包名" } }),
          _c("el-table-column", { attrs: { prop: "channel", label: "渠道" } }),
          _c("el-table-column", {
            attrs: { prop: "ad_channel", label: "广告渠道" }
          }),
          _c("el-table-column", {
            attrs: { prop: "ad_placement", label: "广告位置" }
          }),
          _c("el-table-column", {
            attrs: { prop: "yl_appid", label: "引力appid" }
          }),
          _c("el-table-column", {
            attrs: { prop: "yl_gid", label: "引力广告计划" }
          }),
          _c("el-table-column", {
            attrs: { prop: "yl_aid", label: "引力广告" }
          }),
          _c("el-table-column", {
            attrs: { label: "操作", fixed: "right", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c("div", { staticClass: "x-c" }, [
                      _c(
                        "div",
                        {
                          staticClass: "controlsBtn",
                          on: {
                            click: function($event) {
                              return _vm.$refs.addYlProductMapping.open(row)
                            }
                          }
                        },
                        [_vm._v("修改")]
                      ),
                      _c("div", { staticClass: "controlsBtn-vertical" }),
                      _c(
                        "div",
                        {
                          staticClass: "controlsBtn",
                          on: {
                            click: function($event) {
                              return _vm.handleDelete([row.id])
                            }
                          }
                        },
                        [_vm._v("删除")]
                      )
                    ])
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm.tableData.length
        ? _c("el-pagination", {
            attrs: {
              layout: "total,sizes, prev, pager, next",
              "current-page": _vm.searchData.page,
              total: _vm.total
            },
            on: {
              "size-change": _vm.sizeChange,
              "current-change": _vm.searchClick
            }
          })
        : _vm._e(),
      _c("addYlProductMapping", {
        ref: "addYlProductMapping",
        on: {
          refreshDataList: function($event) {
            return _vm.searchClick(_vm.searchData.page, false)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }